import React from 'react'
import PropTypes from 'prop-types'

import { _CardFooter, _CompareCta, _ListedDays } from './styles'


const CardFooter = ({
  listing, listedDaysText, HiddenCompareCta,
  gaCategory, sourcePage,
}) => (
  <_CardFooter>
    {
      !HiddenCompareCta ?
        <_CompareCta
          listing={listing}
          gaCategory={gaCategory}
          sourcePage={sourcePage}
          listingPreview
        />
        :
        <div />
    }
    <_ListedDays>{listing?.featured ? '' : listedDaysText}</_ListedDays>
  </_CardFooter>
)


CardFooter.propTypes = {
  listing: PropTypes.shape({
    mls_number: PropTypes.string,
    featured: PropTypes.bool,
  }),
  listedDaysText: PropTypes.string,
  HiddenCompareCta: PropTypes.bool,
  gaCategory: PropTypes.string,
  sourcePage: PropTypes.string,
}

export default CardFooter
